import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";
import { listarClientes } from "./clientes";
import { listarCatalogoMercaderias } from "./mercaderiasApi";
import { extraerLista, listarUsuarios } from "./seguridadApi";
import { AGRUPACIONES_RANKING, crearVentasFiltros, validarVentasFiltros } from "./ventasReportesUtils";

export { AGRUPACIONES_RANKING, crearVentasFiltros, validarVentasFiltros } from "./ventasReportesUtils";

const ejecutarReporte = (endpoint, filtros, extra = {}) => {
  const validacion = validarVentasFiltros(filtros);
  if (!validacion.valido) return Promise.resolve({ error: validacion.errores.join(" "), validacion });
  return _Componentes_WebApiCalls_Post(endpoint, { ...crearVentasFiltros(filtros), ...extra });
};

export const obtenerVentasResumen = (filtros) => ejecutarReporte("PISeunReportes/VentasResumen", filtros);
export const obtenerVentasDetalle = (filtros) => ejecutarReporte("PISeunReportes/VentasDetalle", filtros);
export const obtenerVentasEstados = (filtros) => ejecutarReporte("PISeunReportes/VentasEstados", filtros);
export const obtenerVentasRanking = (filtros, AgruparPor) => {
  if (!AGRUPACIONES_RANKING.includes(AgruparPor)) {
    return Promise.resolve({ error: "La agrupacion de ranking no es valida." });
  }
  return ejecutarReporte("PISeunReportes/VentasRanking", filtros, { AgruparPor });
};

export const obtenerOpcionesFiltrosVentas = async (EmpresaId) => {
  const [clientes, productos, operadores, formasPago] = await Promise.all([
    listarClientes({ EmpresaId }),
    listarCatalogoMercaderias({ EmpresaId }),
    listarUsuarios("", true),
    _Componentes_WebApiCalls_Post("Combos/FormasPago", { EmpresaId }),
  ]);
  const respuestas = { clientes, productos, operadores, formasPago };

  return {
    data: {
      clientes: clientes.error ? [] : (clientes.data?.Lista || []),
      productos: productos.error ? [] : (productos.data?.Lista || []),
      operadores: operadores.error ? [] : extraerLista(operadores),
      formasPago: formasPago.error ? [] : (formasPago.data?.Lista || []),
    },
    errores: Object.entries(respuestas)
      .filter(([, respuesta]) => respuesta?.error)
      .map(([catalogo, respuesta]) => ({ catalogo, mensaje: respuesta.error })),
  };
};
